"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrayLayout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const icons_1 = require("../icons/");
const buttons_1 = require("../buttons");
const TrayLayout = ({ isOpen, onToggleClick, toggleText, stageContent, trayContent, toolbarCentralContent, toolbarRightContent, testId, }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, Object.assign({ "data-testid": testId }, { children: [(0, jsx_runtime_1.jsxs)(TopRow, { children: [(0, jsx_runtime_1.jsx)(SideBarOuterWrapper, Object.assign({ isOpen: isOpen }, { children: (0, jsx_runtime_1.jsx)(SideBarInnerWrapper, Object.assign({ isOpen: isOpen }, { children: trayContent })) })), (0, jsx_runtime_1.jsx)(StageWrapper, { children: stageContent })] }), (0, jsx_runtime_1.jsxs)(BottomRow, { children: [(0, jsx_runtime_1.jsx)(ToolbarWrapper, { children: (0, jsx_runtime_1.jsxs)(SideBarButton, Object.assign({ isOpen: isOpen, onClick: onToggleClick, variant: "tertiary", "aria-label": `Toggle ${toggleText}`, "data-testid": "tray-toggle-button" }, { children: [toggleText, (0, jsx_runtime_1.jsx)(SideBarButtonDecorator, { isopen: isOpen ? 'true' : null, name: "CaretIcon" })] })) }), (0, jsx_runtime_1.jsx)(CenterToolbarWrapper, { children: toolbarCentralContent }), (0, jsx_runtime_1.jsx)(ToolbarWrapper, { children: toolbarRightContent })] })] })));
};
exports.TrayLayout = TrayLayout;
const Wrapper = styled_1.default.div(({ theme }) => {
    const SPACE_AROUND_MODAL = 0;
    return {
        backgroundColor: theme.colors.white,
        width: `calc(100vw - ${2 * SPACE_AROUND_MODAL}px)`,
        height: `calc(100vh - ${2 * SPACE_AROUND_MODAL}px)`,
        display: 'grid',
        gridTemplateRows: `calc(100vh - ${2 * SPACE_AROUND_MODAL + 56}px) 56px`,
    };
});
const SideBarOuterWrapper = styled_1.default.div(({ isOpen, theme }) => ({
    overflowY: 'auto',
    overflowX: 'hidden',
    width: `${isOpen ? '450' : '0'}px`,
    transition: 'width 150ms ease-out',
    backgroundColor: theme.colors.white,
    zIndex: 1,
    position: 'relative',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        width: `${isOpen ? '400' : '0'}px`,
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        width: `${isOpen ? '100vw' : '0px'}`,
        height: `${isOpen ? '450' : '0'}px`,
        transition: 'height 150ms ease-out',
        zIndex: isOpen ? 1 : 0,
        position: 'absolute',
        bottom: '0',
    },
}));
const SideBarInnerWrapper = styled_1.default.div(({ isOpen, theme }) => ({
    width: '450px',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        width: '400px',
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        width: '100vw',
        height: `${isOpen ? '450' : '0'}px`,
        transition: 'height 150ms ease-out',
    },
}));
const TopRow = styled_1.default.div(({ theme }) => ({
    position: 'relative',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: `max-content auto`,
    transition: 'all 150ms ease-in',
    zIndex: 1,
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        display: 'block',
    },
}));
const StageWrapper = styled_1.default.div(({ theme }) => ({
    position: 'relative',
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        height: '100%',
    },
}));
const BottomRow = styled_1.default.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    transition: 'all 150ms ease-in',
    backgroundColor: theme.colors.grey10,
    zIndex: 2,
    [`@media ${theme.mediaBreakpoints.small}`]: {
        gridTemplateColumns: '400px auto auto',
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        gridTemplateColumns: '100% 0px 0px',
        position: 'fixed',
        bottom: '0',
        height: '56px',
    },
}));
const SideBarButton = (0, styled_1.default)(buttons_1.Button)(({ isOpen, theme }) => ({
    position: 'relative',
    overflow: 'visible',
    height: '100%',
    zIndex: 1,
    backgroundColor: theme.colors.white,
    borderRadius: `0px ${isOpen ? '0' : '30px'} 30px 0px`,
    color: theme.colors.grey90,
    width: `${isOpen ? '450px' : '215px'}`,
    padding: '0 32px',
    transition: 'all 150ms ease-out',
    ':hover, :active, :focus': {
        backgroundColor: theme.colors.white,
        color: theme.colors.azure,
        textDecoration: 'none',
        borderRadius: `0px ${isOpen ? '0' : '30px'} 30px  0px`,
        [`@media ${theme.mediaBreakpoints.xsmall}`]: {
            borderRadius: '0px',
        },
    },
    ':hover svg, :active svg, :focus svg': {
        backgroundColor: theme.colors.white,
        color: theme.colors.azure,
    },
    ':hover svg path, :active svg path, :focus svg path': {
        fill: theme.colors.azure,
    },
    span: {
        justifyContent: 'flex-end',
        marginRight: '16px',
        [`@media ${theme.mediaBreakpoints.xsmall}`]: {
            justifyContent: 'flex-start',
        },
    },
    [`@media ${theme.mediaBreakpoints.small}`]: {
        width: `${isOpen ? '400px' : '215px'}`,
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        width: '100vw',
        borderRadius: '0px',
    },
}));
// isopen is lowercased and of type string, otherwise it will get passed to the dom due to prop spreading to the AppIcon
// and cause a react warning in the console
const SideBarButtonDecorator = (0, styled_1.default)(icons_1.AppIcon)(({ isopen, theme }) => ({
    position: 'absolute',
    backgroundColor: theme.colors.white,
    right: '10px',
    opacity: 1,
    borderRadius: '50%',
    transform: `scale(1.2) rotate(${isopen ? '90deg' : '-90deg'}) !important`,
    transition: 'all 150ms ease-out',
    padding: '0 3px',
    '& path': {
        transition: 'fill 150ms ease-in',
        fill: theme.colors.azure,
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        transform: `scale(1.2) rotate(${isopen ? '0deg' : '180deg'}) !important`,
        position: 'relative',
        marginLeft: '6px',
        right: '0',
    },
}));
const ToolbarWrapper = styled_1.default.div({
    display: 'flex',
    height: '100%',
    width: '100%',
});
const CenterToolbarWrapper = styled_1.default.div(({ theme }) => ({
    display: 'flex',
    height: '100%',
    width: '100%',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        justifyContent: 'center',
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        display: 'none',
    },
}));
//# sourceMappingURL=trayLayout.js.map